export class Property {
  constructor(cell, snapshot = {}) {
    this.id = cell.index;
    this.ownerId = snapshot.ownerId ?? null;
    this.houses = Number(snapshot.houses ?? 0);
    this.mortgaged = Boolean(snapshot.mortgaged);
  }

  get hasHotel() {
    return this.houses === 5;
  }

  reset() {
    this.ownerId = null;
    this.houses = 0;
    this.mortgaged = false;
  }

  toPublic() {
    return {
      id: this.id,
      ownerId: this.ownerId,
      houses: this.houses,
      mortgaged: this.mortgaged,
    };
  }

  toSnapshot() {
    return this.toPublic();
  }
}
